// ─── Carte d'un forfait (Core) ────────────────────────────────────
// Visuel repris de MoPCal : nom + prix en en-tête, puis ce que le forfait
// apporte en liste de « ✓ » — l'utilisateur doit comprendre ce qu'il gagne
// sans ouvrir un tableau comparatif. Le forfait le plus haut est mis en avant.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useT } from '../i18n/LangueContext';

// `libelleAction`/`actionActive` (20/08, paiement) : un forfait PAYANT en
// cours reste actionnable (« Passer en gratuit ») là où un forfait gratuit ou
// hors-cat en cours affiche un bouton désactivé « Actuel » — le paiement
// contourne le circuit de demande, donc ce n'est plus le même bouton.
export default function CartePlan({ plan, nom, jetons, nbFonctions, actuel, enAttente, bloque, onDemander, libelleAction, actionActive }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const p = plan || {};
  const inf = (v) => (v == null ? '∞' : String(v));
  const desactive = (actuel && !actionActive) || enAttente || bloque;

  // Ce que le forfait apporte, dans l'ordre de ce qui compte le plus.
  const atouts = [
    jetons && t('forfait.featJetons', { g: jetons.gestion, v: jetons.vue }),
    nbFonctions != null && t('forfait.featFonctions', { n: nbFonctions }),
    t('forfait.featPieces', { n: inf(p.piecesJointes) }),
    t('forfait.featHistorique', { n: p.historiqueDays == null ? '∞' : p.historiqueDays }),
    p.exportPdf && t('forfait.featExportPdf'),
    p.syncCalendrier && t('forfait.featSync'),
    (!p.pubFixe && !p.pubEvenement) ? t('forfait.featSansPub')
      : (!p.pubEvenement ? t('forfait.featSansPubPleinEcran') : null),
  ].filter(Boolean);

  return (
    <View style={[s.carte, actuel && s.carteOn]}>
      <View style={s.tete}>
        <Text style={[s.nom, actuel && { color: UI.accent }]}>{nom}</Text>
        {p.prix
          ? <Text style={s.prix}>{p.prix.mensuel}€<Text style={s.prixSub}>{t('forfait.parMois')}</Text></Text>
          : <Text style={s.prix}>0€</Text>}
      </View>
      <View style={s.atouts}>
        {atouts.map((a, i) => <Text key={i} style={s.atout}>✓ {a}</Text>)}
      </View>
      <TouchableOpacity style={[s.btn, desactive && s.btnOff]}
        disabled={desactive} onPress={onDemander}>
        <Text style={[s.btnTxt, desactive && s.btnTxtOff]}>
          {libelleAction || (actuel ? t('forfait.actuel') : enAttente ? t('forfait.demandeEnvoyee') : t('forfait.demander'))}
        </Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  carte: { backgroundColor: UI.card, borderRadius: 15, borderWidth: 0.5, borderColor: UI.border,
           padding: 14, marginBottom: 10, gap: 10 },
  carteOn: { borderColor: UI.accent, borderWidth: 1.5, backgroundColor: UI.accentTint },
  tete: { flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between' },
  nom: { fontSize: 16, fontWeight: '900', color: UI.ink },
  prix: { fontSize: 17, fontWeight: '900', color: UI.ink },
  prixSub: { fontSize: 11, fontWeight: '700', color: UI.muted },
  atouts: { gap: 3 },
  atout: { fontSize: 12.5, color: UI.muted, lineHeight: 17 },
  btn: { backgroundColor: UI.accent, borderRadius: 11, paddingVertical: 10, alignItems: 'center' },
  btnOff: { backgroundColor: UI.champ },
  btnTxt: { color: '#fff', fontSize: 13.5, fontWeight: '800' },
  btnTxtOff: { color: UI.muted },
});
